// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "container-3oSrA";
var _3 = "header-QHBez";
var _4 = "header__text-1ZuoD";
var _5 = "notification-LzMRY";
var _6 = "closeButton-2z1Iw";
var _7 = "description-3o366";
var _8 = "passengers-25ujU";
var _9 = "passengerType-1VO4I";
var _a = "age-3SoW_";
var _b = "info__icon-1Uz2O";
var _c = "item-2KUTP";
var _d = "buttons-evBrm";
var _e = "newSearch-1D5sw";
var _f = "continueButton-3tlNV";
var _10 = "increase-19Kw2";
var _11 = "decrease-3yd_i";
var _12 = "counter-2OnGf";
export { _1 as "__esModule", _2 as "container", _3 as "header", _4 as "header__text", _5 as "notification", _6 as "closeButton", _7 as "description", _8 as "passengers", _9 as "passengerType", _a as "age", _b as "info__icon", _c as "item", _d as "buttons", _e as "newSearch", _f as "continueButton", _10 as "increase", _11 as "decrease", _12 as "counter" }
export default { "__esModule": _1, "container": _2, "header": _3, "header__text": _4, "notification": _5, "closeButton": _6, "description": _7, "passengers": _8, "passengerType": _9, "age": _a, "info__icon": _b, "item": _c, "buttons": _d, "newSearch": _e, "continueButton": _f, "increase": _10, "decrease": _11, "counter": _12 }
